import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_NEW_JOB_OFFERS } from '@gql/alerts';

export const useGetDashboardNewJobOffers = (date?: Date, method?: 'direct_email' | 'premium', limit = 10) => {
    const { data, loading, error, refetch } = useQuery(GET_DASHBOARD_NEW_JOB_OFFERS, {
        variables: { limit, ...(date && { date }), ...(method && { method }) },
        notifyOnNetworkStatusChange: true,
    });

    return {
        jobOffers: data?.getDashboardNewJobOffers ?? [],
        loading,
        error,
        refetch,
    };
};
